import { PageWrapper } from '@qonsoll/react-design'

const TermsAndConditionsOfUse = () => {
  return (
    <PageWrapper
      headingProps={{ title: 'Terms and Conditions of Use', titleSize: 3 }}>
      content
    </PageWrapper>
  )
}

export default TermsAndConditionsOfUse
